import { Button, Text } from '@lune-fe/lune-ui-lib'
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight'
import Box from '@mui/material/Box'
import Image from 'next/image'

import FullScreenOnMobileWrapper from '@/components/FullScreenOnMobileWrapper'
import useDevice from '@/hooks/useDevice'

const SustainabilityLead = () => {
    const { smScreen, mdScreen, xsScreen } = useDevice()

    return (
        <FullScreenOnMobileWrapper>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    position: 'relative',
                    overflow: 'hidden',
                    ...(smScreen
                        ? {
                              pt: 6,
                              pb: 6,
                              pl: xsScreen ? 3 : 6,
                              pr: xsScreen ? 3 : 6,
                              borderRadius: 'none',
                          }
                        : {
                              pt: 8,
                              pb: 8,
                              pl: 9,
                              pr: 9,
                              borderRadius: '32px',
                          }),
                    img: {
                        position: 'absolute',
                        top: 0,
                        width: 'auto',
                        height: 'auto',
                        zIndex: -1,
                        right: '-50%',
                        left: '-50%',
                        margin: 'auto',
                    },
                }}
            >
                <Image
                    src={'/images/sustainability-lead/sustainability-lead-gradient.png'}
                    width={2050}
                    height={365}
                    alt={`sustainability-lead`}
                />
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: smScreen ? 'flex-start' : 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        flexDirection: smScreen ? 'column' : 'row',
                        gap: smScreen ? 4 : 6,
                    }}
                >
                    <Text
                        variant={mdScreen ? 'h5' : 'h4'}
                        sx={{
                            flex: '0 1 auto',
                        }}
                    >
                        Get ahead of competitors by engaging a new buyer persona – the
                        sustainability lead.
                    </Text>
                    <Box
                        sx={{
                            flex: '0 1 auto',
                            width: smScreen ? '100%' : 'auto',
                        }}
                    >
                        <Button
                            href="/request-a-demo"
                            sx={{ width: smScreen ? '100%' : 'auto' }}
                            variant={'contained'}
                            leftIcon={<ArrowCircleRightIcon />}
                        >
                            Request a demo
                        </Button>
                    </Box>
                </Box>
            </Box>
        </FullScreenOnMobileWrapper>
    )
}

export default SustainabilityLead
